module.exports = __webpack_public_path__ + "static/media/False Consensus - john-moeses-bauan-2zUWGeg8DTw-unsplash.d408eadd.jpg";